import JsonApi from 'devour-client'
import models from './models'
import axios from 'axios'
import {britecoreVersionRequestMiddleware, errorMiddleware} from './middlewares'

const api = new JsonApi({
  apiUrl: process.env.VUE_APP_API_URL || '',
  trailingSlash: {resource: true, collection: true}.collection
})
api.axios = axios

models.forEach(m => api.define(m.resourceName, m.fields, m.options))
api.insertMiddlewareBefore('axios-request', britecoreVersionRequestMiddleware)
api.replaceMiddleware('errors', errorMiddleware)
export default api
